module.exports = __webpack_public_path__ + "static/img/Apisai-Koroisau.bdf9e82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Apisai-Koroisau.jpg
// module id = DfiA
// module chunks = 0